import React from "react";
import { Outlet } from "react-router-dom";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import WingmanWidget from "@/components/WingmanWidget";
import QuickQuotePopup from "@/components/QuickQuotePopup";

export default function PublicLayout() {
  return (
    <div className="App flex flex-col min-h-screen" data-testid="public-layout">
      <Header />
      <main className="flex-1">
        <Outlet />
      </main>
      <Footer />
      <WingmanWidget />
      <QuickQuotePopup />
    </div>
  );
}
